import { ItemsModel } from './items.model';

export class ReviewServiceModel {

    items: ItemsModel[];


}
